/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CloudConnectorUserModule
 */

import { L10nService } from '@vmw/ngx-vip';
import {
    Component,
    Input,
} from '@angular/core';
import { GCPCredentialsConfigItem } from 'ajs/modules/cloud-connector-user';

import * as l10n from './gcp-credentials.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component for the GCPCredentials modal.
 * @author alextsg
 */
@Component({
    selector: 'gcp-credentials',
    templateUrl: './gcp-credentials.component.html',
})
export class GcpCredentialsComponent {
    /**
     * GCPCredentialsConfigItem Config Item.
     */
    @Input() public editable: GCPCredentialsConfigItem;

    /**
     * Get keys from source bundles for template usage
     */
    public readonly l10nKeys = l10nKeys;

    public constructor(
        l10nService: L10nService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }
}
